import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/Base.service';


@Injectable({
    providedIn: 'root'
})
export class NovidadeSistemaService extends BaseService {
	constructor(){
		super('/novidadeSistema/')
	}
}
